import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import fb from "../assets/fb.png";
import tw from "../assets/tw.png";
import ig from "../assets/ig.png";
import linkedin from "../assets/linkedin.png";

function Footer({ mode }) {
  return (
    <>
      <div className="footer">

        {/* LEFT SECTION */}
        <div className="footer-section">
          <div className="logo footer-logo">
            <img src={logo} alt="logo" />
            <div>
              <h3>
                {mode === "school"
                  ? "TEJKIRTI LITTLE STAR"
                  : "TEJKIRTI"}
              </h3>

              <p className="sub-text">
                {mode === "school"
                  ? "Pre-School"
                  : "Senior Women’s College"}
              </p>
            </div>
          </div>

          <p>
            {mode === "school"
              ? "Nurturing young minds with creativity, fun learning, and holistic development."
              : `"Building Empowered Women Through Excellence in Education and Development"`}
            
            {" "}Affiliated to{" "}
            <a
              href="https://sndt.digitaluniversity.ac/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              S.N.D.T. WOMEN'S UNIVERSITY, MUMBAI
            </a>
          </p>

          {/* SOCIAL ICONS */}
          <div className="social">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <img src={fb} alt="fb" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer">
              <img src={tw} alt="tw" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              <img src={ig} alt="ig" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer">
              <img src={linkedin} alt="in" />
            </a>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-section">
          <h4>Quick Links</h4>

          <Link to="/about" className="footer-link">About</Link>
          <Link to="/programs" className="footer-link">Programs</Link>
          <Link to="/facilities" className="footer-link">Facilities</Link>
          <Link to="/admission" className="footer-link">Admission</Link>

          {/* Only for college */}
          {mode !== "school" && (
            <Link to="/faculty" className="footer-link">Faculty</Link>
          )}

          <Link to="/contact" className="footer-link">Contact</Link>
        </div>

        {/* IMPORTANT LINKS */}
        <div className="footer-section">
          <h4>Important Links</h4>

          <a
            href="https://htedu.maharashtra.gov.in/Main/"
            target="_blank"
            rel="noreferrer"
            className="footer-link"
          >
            Higher Education Department Maharashtra
          </a>

          <a
            href="https://mahadbt.maharashtra.gov.in"
            target="_blank"
            rel="noreferrer"
            className="footer-link"
          >
            Mahadbt Scholarship Portal
          </a>

          <a
            href="https://sndt.digitaluniversity.ac/"
            target="_blank"
            rel="noreferrer"
            className="footer-link"
          >
            S.N.D.T University Mumbai
          </a>
        </div>

        {/* CONTACT */}
        <div className="footer-section">
          <h4>Contact Us</h4>

          <p>📍 Bhavsingpura, Chh. Sambhajinagar</p>
          <p>📞 9595302222, 9404677689</p>
          <p>💬 WhatsApp: 9595302222</p>
          <p>✉ tejkirticollege584@gmail.com</p>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <p>
          © 2026 {mode === "school"
            ? "Tejkirti Little Star Pre-School"
            : "Tejkirti Senior Women’s College"}.
          All Rights Reserved.
        </p>

        {/* Only for college */}
        {mode !== "school" && (
          <p>
            Affiliated to{" "}
            <a
              href="https://sndt.digitaluniversity.ac/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              S.N.D.T Women’s University, Mumbai
            </a>{" "}
            | Managed by Adarsh Shikshan Prasarak Mandal
          </p>
        )}

        <p className="footer-codes">
          College Code: 587 | Center Code: 471 | AISHE Code: C-76858
        </p>
      </div>
    </>
  );
}

export default Footer;